import config from '@/config';
import logger from '@/util/logger';
import { initializeDao } from '@rock/dao';
import { clientAdapter, initializeFirebase } from '@rock/db-admin';

initializeFirebase(config.firebase.config);
initializeDao({ adapter: clientAdapter, loggerFactory: logger });
